import styled from "styled-components";
import {
  NewButton,
  NewTypography,
  NewCheckBox,
  NewRadioGroup,
  NewTextField,
} from "@bca/ui-library";
import theme from "../../styles/theme";

export const StyledFinalDetails = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 1.5rem;
`;

export const StyledTitle = styled(NewTypography)`
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  line-height: 29px;
  margin-top: 3.75rem;
`;

export const StyledSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? "1rem" : "3.5rem")};
`;

export const StyledText = styled(NewTypography)`
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 22px;
  color: ${theme.color.radioLabel};
`;

export const StyledInterestsGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const StyledInterestsLabel = styled(StyledText)`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
`;

export const StyledInterestsButtonsGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: ${(props) => (props.isMobile ? "1rem" : "0.5rem")};
  column-gap: 0.5rem;
`;

export const StyledInterestButton = styled(NewButton)`
  border-radius: 5px;
  height: 35px;
`;

export const StyledRadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? "1.5rem" : "2rem")};
`;

export const StyledRadioLabel = styled(StyledText)`
  min-width: ${(props) => (props.isMobile ? null : "23.3rem")};
  font-size: 14px;
  font-weight: 700;
`;

export const StyledRequired = styled.span`
  color: ${theme.color.red};
  margin-left: 4px;
`;

export const StyledOtherInformGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => (props.isMobile ? "1.125rem" : "1.5625rem")};
  margin-top: ${(props) => (props.isMobile ? "1.5625rem" : "2rem")};
`;

export const StyledOtherInformLabel = styled(StyledText)`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
`;

export const StyledCheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${(props) => (props.isMobile ? "1.125rem" : "1.6875rem")};
`;

export const StyledCheckbox = styled(NewCheckBox)``;

export const StyledUploadDocumentsGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? "1.1875rem" : "2rem")};
`;

export const StyledUploadDocumentsTtile = styled(StyledText)`
  font-weight: 700;
  line-height: ${(props) => (props.isMobile ? "19px" : "16px")};
`;

export const StyledUploadDocumentsParagraph = styled(StyledText)`
  font-weight: ${(props) => (props.isMobile ? "500" : "400")};
  font-size: ${(props) => (props.isMobile ? "11px" : "13px")};
  line-height: ${(props) => (props.isMobile ? "29px" : "15px")};
  margin-top: ${(props) => (props.isMobile ? "0" : "1.125rem")};
  &:nth-child(2) {
    margin-top: ${(props) => (props.isMobile ? "1px " : "1rem")};
  }
`;

export const StyledUploadDocumentsSpecificText = styled(StyledText)`
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.color.specificTextColor};
`;

export const StyledUploadDocumentsSpecificCheckboxContainer = styled.div`
  margin-top: 1.125rem;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.color.specificTextColor};
`;

export const StyledSpecificForCountryRadioGroup = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  flex-wrap: wrap;
  column-gap: 0.6875rem;
`;

export const StyledSpecificForCountryRadioLabel = styled(StyledText)`
  align-self: ${(props) => (props.isMobile ? null : "center")};
  min-width: ${(props) => (props.isMobile ? null : "23.3rem")};
`;

export const StyledUploadGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) => (props.isMobile ? "1.3125rem" : "1.9375rem")};
  row-gap: 5px;
`;

export const StyledUploadDocumentsLabel = styled(StyledText)`
  font-weight: 500;
`;

export const StyledUploadDocumentsInfo = styled.div``;

export const StyledUploadDocumentsInfoText = styled(StyledText)`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.color.darkBlue};
`;

export const StyledUploadButtonContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  row-gap: 1.5625rem;
  column-gap: 1rem;
  margin-top: 5px;
`;

export const StyledUploadButtonsGroup = styled.div``;

export const StyledUploadButton = styled(NewButton)`
  max-width: 13.5rem;
`;

export const StyledTCGroup = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin-top: 2.5rem;
  column-gap: 0.75rem;
  align-items: center;
`;

export const StyledTCCheckbox = styled(NewCheckBox)``;

export const StyledTCLabel = styled(StyledText)`
  display: flex;
  align-items: center;
  font-weight: ${(props) => (props.isMobile ? "400" : "500")};
`;

export const StyledHoverText = styled.span`
  color: ${theme.color.ctaActionLink};
`;

export const StyledSignGroup = styled.div`
  margin-top: 2.4375rem;
`;

export const StyledSignLabel = styled(StyledText)`
  font-weight: 500;
  font-size: 14px;
  line-height: 29px;
`;

export const StyledSignButton = styled(NewButton)`
  border-radius: 5px;
  height: 5.25rem;
  margin-top: 1.5rem;
`;

export const StyledRadioButtonGroup = styled(NewRadioGroup)`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  column-gap: 1.875rem;
  & label {
    & span {
      font-style: normal;
      font-weight: 600 !important;
      font-size: 13px !important;
      line-height: 22px !important;
      color: #043074;
    }
  }
`;

export const StyledInput = styled(NewTextField)`
  width: 100%;
`;

export const StyledInputGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
`;
